import React, { useEffect } from 'react';

const Videos = ({ displayStyle }) => {
    return <div>Videos - {displayStyle}</div>;
};

export default Videos;
